








import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { TypedForm } from '@/shared/forms/typed-form'
import { ProjectRequest } from '@/api/generated'
import { NewProjectForm } from '@/business/project/components/new-project/new-project-form'
import NewProject from '@/business/project/components/new-project/new-project.vue'
import EditProject from '@/business/project/components/edit-project/edit-project.vue'

@Component({
  name: 'project-settings',
  components: { EditProject, NewProject },
})
export default class ProjectSettingsPage extends Vue {
  @Prop()
  public readonly id!: number

  public activeStep = 1
  public form!: TypedForm<ProjectRequest, NewProjectForm>

  get isNew() {
    return this.id === -1
  }
}
